import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectOutletComponent } from './select-outlet.component';

const routes: Routes = [
  {
    path: '',
    component: SelectOutletComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectOutletRoutingModule {}
